import { useEffect } from "react";
import { useUser } from "./useUser";
import { useProfile } from "./useProfile";
import { useAuth } from "./useAuth";

export function useAuthSync() {
    const { data: user, isLoading: userLoading, error: userError } = useUser();
    const {
        data: profile,
        isLoading: profileLoading,
        error: profileError,
    } = useProfile(
        user?.id || null,
        { enabled: !!user?.id } // Only run when user exists
    );
    const { setAuthData } = useAuth();

    // Update auth store whenever user or profile data changes
    useEffect(() => {
        const isLoading = userLoading || profileLoading;
        setAuthData(user || null, profile || null, isLoading);
    }, [user, profile, userLoading, profileLoading, setAuthData]);

    return {
        user,
        profile,
        isLoading: userLoading || profileLoading,
        userError,
        profileError,
    };
}
